import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  PatientWorkflowActions,
  PatientWorkflowActionTypes,
} from './patient-workflow.actions';
import { PatientWorkflow } from './patient-workflow.model';

export interface State extends EntityState<PatientWorkflow> {}

export const adapter: EntityAdapter<PatientWorkflow> = createEntityAdapter<PatientWorkflow>();

export const initialState: State = adapter.getInitialState({});

export function reducer(state = initialState, action: PatientWorkflowActions): State {
  switch (action.type) {
    case PatientWorkflowActionTypes.AddPatientWorkflow: {
      return adapter.addOne(action.payload.patientWorkflow, state);
    }

    case PatientWorkflowActionTypes.UpsertPatientWorkflow: {
      return adapter.upsertOne(action.payload.patientWorkflow, state);
    }

    case PatientWorkflowActionTypes.AddPatientWorkflows: {
      return adapter.addMany(action.payload.patientWorkflows, state);
    }

    case PatientWorkflowActionTypes.UpsertPatientWorkflows: {
      return adapter.upsertMany(action.payload.patientWorkflows, state);
    }

    case PatientWorkflowActionTypes.UpdatePatientWorkflow: {
      return adapter.updateOne(action.payload.patientWorkflow, state);
    }

    case PatientWorkflowActionTypes.UpdatePatientWorkflows: {
      return adapter.updateMany(action.payload.patientWorkflows, state);
    }

    case PatientWorkflowActionTypes.DeletePatientWorkflow: {
      return adapter.removeOne(action.payload.id, state);
    }

    case PatientWorkflowActionTypes.DeletePatientWorkflows: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case PatientWorkflowActionTypes.LoadPatientWorkflows: {
      return adapter.setAll(action.payload.patientWorkflows, state);
    }

    case PatientWorkflowActionTypes.ClearPatientWorkflows: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
